import React from "react";
import { isMobile } from "../../../utils/deviceInfo";
import "./ColumnResizeHandle.css";

// Presentational grip that sits on a header cell's right border. The parent
// header must be position:relative so this absolutely-positioned strip anchors
// to its right edge. Desktop-only: renders nothing on touch/mobile.
//
// All pointer/click handlers stopPropagation so a drag (or a stray click on the
// strip) never bubbles to the header's three-dots (menu / sort) control.
const ColumnResizeHandle = ({
  columnKey,
  currentWidth,
  startResize,
  resetColumn,
}) => {
  if (isMobile) {
    return null;
  }

  const onPointerDown = (event) => {
    event.stopPropagation();
    // Measure the live rendered width of the header cell (the grip's parent) so
    // the drag starts from the actual on-screen width, whether that is a grid
    // default (percentage) or a previously applied pixel override.
    let startWidth = currentWidth;
    const cell = event.currentTarget.parentElement;
    if (cell && cell.getBoundingClientRect) {
      const rect = cell.getBoundingClientRect();
      if (rect && rect.width) {
        startWidth = rect.width;
      }
    }
    if (startResize) {
      startResize(columnKey, startWidth, event);
    }
  };

  const onClick = (event) => {
    event.stopPropagation();
  };

  const onDoubleClick = (event) => {
    event.stopPropagation();
    if (resetColumn) {
      resetColumn(columnKey);
    }
  };

  return (
    <div
      className="col-resize-handle"
      role="separator"
      aria-orientation="vertical"
      aria-label="Drag to resize column"
      onPointerDown={onPointerDown}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    />
  );
};

export default ColumnResizeHandle;
